import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import FormControlLabel from '@mui/material/FormControlLabel';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import React, { Dispatch, SetStateAction, useState } from 'react';
import { ajaxLogin } from '../../core/services/authenticationService';
import inMemoryJwt from '../../core/services/inMemoryJwtService';

function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://kti/">
                Kings Tobacco International
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const theme = createTheme();

interface SignInProps {
    setIsUserLogged: Dispatch<SetStateAction<boolean>>
}

const SignIn = (props: SignInProps) => {
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [showErrorMsg, setShowErrorMsg] = useState(false);

    const handleSubmit = (event: any) => {

        event.preventDefault();
        const data = new FormData(event.currentTarget);

        const postBody = {
            username: data.get('username'),
            password: data.get('password')
        }
            ;

        ajaxLogin(postBody)
            .then((res: any) => {
                const { token, tokenExpiration } = res;
                inMemoryJwt.setToken(token, tokenExpiration);

                setTimeout(() => {
                    props.setIsUserLogged(true);
                }, 3000);
            }).catch(err => {
                console.error(err);
                setShowErrorMsg(true);

                setTimeout(() => {
                    setShowErrorMsg(false);
                }, 3000);
            });
    };

    return (
        <ThemeProvider theme={theme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: '#C81528' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Sign in
                    </Typography>
                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                        <TextField                            
                            margin="normal"
                            required
                            fullWidth
                            id="username"
                            label="Username"
                            name="username"
                            autoComplete="username"
                            autoFocus
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                        />
                        <FormControlLabel
                            control={<Checkbox value="remember" color="primary" />}
                            label="Remember me"
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Sign In
                        </Button>
                    </Box>
                </Box>
                <Copyright sx={{ mt: 8, mb: 4 }} />
            </Container>
            {
                showSuccessMsg ?
                    <div>Success</div>
                    : null
            }

            {
                showErrorMsg ?
                    <div>Error</div>
                    : null
            }
        </ThemeProvider>
    );
}

export default SignIn;